import { useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from 'react-redux';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './assets/css/ads.css';
import './assets/css/app.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/custom.css';
import './assets/css/responsive.css';
import './assets/css/wysiwyg.css';
import './assets/mystyle.scss';
import Dashboard from './containers/dashboard/Dashboard';
import Login from './containers/login/Login';
import PageNotFound from './containers/notfound/PageNotFound';
import Profile from './containers/profile/Profile';
import setAuthToken from './domain/setAuthToken';
import BeforeLoginRoutes from './shared/Routes/BeforeLoginRoutes';
import PrivateRoutes from './shared/Routes/PrivateRoutes';
import RoleBasedRoute from './shared/Routes/RoleBasedRoute';
import { loadUser } from './store/actions/auth';
import store from './store/store';
import socket from './socket';
// import setAuthToken from "./domain/setAuthToken";

import AddClient from './containers/clients/AddClient';
import AllClients from './containers/clients/AllClients';
import ClientDashboard from './containers/clients/ClientDashboard';
import ClientView from './containers/clients/ClientView';
import EditClient from './containers/clients/EditClient';
import SuperAdminDashboard from './containers/clients/SuperAdminDashboard';
import ViewClient from './containers/clients/ViewClient';

import AddEmployee from './containers/employees/AddEmployee';
import AllEmployees from './containers/employees/AllEmployees';
import EditEmployee from './containers/employees/EditEmployee';
import ViewEmployee from './containers/employees/ViewEmployee';

import AddStatus from './containers/statuss/AddStatus';
import AllStatuss from './containers/statuss/AllStatuss';
import EditStatus from './containers/statuss/EditStatus';
import ViewStatus from './containers/statuss/ViewStatus';

import AddActivity from './containers/activitys/AddActivity';
import AllActivitys from './containers/activitys/AllActivitys';
import BulkAddActivity from './containers/activitys/BulkAddActivity';
import EditActivity from './containers/activitys/EditActivity';
import ViewActivity from './containers/activitys/ViewActivity';

import AddBill from './containers/bills/AddBill';
import AllBills from './containers/bills/AllBills';
import EditBill from './containers/bills/EditBill';
import ViewBill from './containers/bills/ViewBill';

import AddProcess from './containers/processs/AddProcess';
import AllProcesss from './containers/processs/AllProcesss';
import EditProcess from './containers/processs/EditProcess';
import ViewProcess from './containers/processs/ViewProcess';

import AddBankaccount from './containers/bankaccounts/AddBankaccount';
import AllBankaccounts from './containers/bankaccounts/AllBankaccounts';
import EditBankaccount from './containers/bankaccounts/EditBankaccount';
import ViewBankaccount from './containers/bankaccounts/ViewBankaccount';

import AddActivitystatus from './containers/activitystatuss/AddActivitystatus';
import AllActivitystatuss from './containers/activitystatuss/AllActivitystatuss';
import EditActivitystatus from './containers/activitystatuss/EditActivitystatus';
import ViewActivitystatus from './containers/activitystatuss/ViewActivitystatus';

import AddReviewstatus from './containers/reviewstatuss/AddReviewstatus';
import AllReviewstatuss from './containers/reviewstatuss/AllReviewstatuss';
import EditReviewstatus from './containers/reviewstatuss/EditReviewstatus';
import ViewReviewstatus from './containers/reviewstatuss/ViewReviewstatus';

import AddLead from './containers/leads/AddLead';
import AllLeads from './containers/leads/AllLeads';
import EditLead from './containers/leads/EditLead';
import ViewLead from './containers/leads/ViewLead';

import AddGroup from './containers/groups/AddGroup';
import AllGroups from './containers/groups/AllGroups';
import EditGroup from './containers/groups/EditGroup';
import ViewGroup from './containers/groups/ViewGroup';

import AddServicepackage from './containers/servicepackages/AddServicepackage';
import AllServicepackages from './containers/servicepackages/AllServicepackages';
import EditServicepackage from './containers/servicepackages/EditServicepackage';
import ViewServicepackage from './containers/servicepackages/ViewServicepackage';

import AddBillreview from './containers/billreviews/AddBillreview';
import AllBillreviews from './containers/billreviews/AllBillreviews';
import EditBillreview from './containers/billreviews/EditBillreview';
import ViewBillreview from './containers/billreviews/ViewBillreview';

import AddAd from './containers/ads/AddAd';
import AllAds from './containers/ads/AllAds';
import EditAd from './containers/ads/EditAd';
import ImoortCSV from './containers/ads/ImoortCSV';
import ViewAd from './containers/ads/ViewAd';

// Ads Activities components
import AdsActivitiesList from './containers/ads-activities/AdsActivitiesList';
import AdsActivityDetails from './containers/ads-activities/AdsActivityDetails';
import AdsActivityCreate from './containers/ads-activities/AdsActivityCreate';
import AdsActivityCreateTest from './containers/ads-activities/AdsActivityCreateTest';

import AddActivitycycle from './containers/activitycycles/AddActivitycycle';
import AllActivitycycles from './containers/activitycycles/AllActivitycycles';
import EditActivitycycle from './containers/activitycycles/EditActivitycycle';
import ViewActivitycycle from './containers/activitycycles/ViewActivitycycle';

import AllAdsreports from './containers/google_ads_reports/AllAdsreports';
// import AllFacebookAdsreports from './containers/adsreports/AllFacebookReports';
import CampaignDetailsView from './containers/google_ads_reports/_components/campaign-details';

// New Facebook Ads Reports components
import AllFacebookAdsReports from './containers/facebook_ads_reports/AllFacebookAdsReports';

// New Google Ads Reports components

import AuthenticatedEffects from './AuthenticatedEffects';
import AddCalendar from './containers/activitycycles/AddCalendar';
import AddMultipleActivity from './containers/activitys/add-multiple-activity-new';
import { AdsDashboard } from './containers/adsdashboard/AdsDashboard';
import Chat from './containers/chat/Chat';
import ClientAdsModel from './containers/clientsads/ClientAdsModel';
import ClientsAds from './containers/clientsads/ClientsAds';
import SingleClientAds from './containers/clientsads/SingleClientAds';
import AddEmployeereport from './containers/employeereports/AddEmployeereport';
import AllEmployeereports from './containers/employeereports/AllEmployeereports';
import EditEmployeereport from './containers/employeereports/EditEmployeereport';
import MyProfile from './containers/employeereports/MyProfile';
import ViewEmployeereport from './containers/employeereports/ViewEmployeereport';
import Event from './containers/events/Event';
import GalleryPage from './containers/gallery/GalleryPage';
import Test from './containers/test/Test';

function App() {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  console.log('isAuthenticated: xxxxx', isAuthenticated);

  useEffect(() => {
    //First we have to bring(get that) token, which is saved in local storage
    const token = localStorage.getItem('token');
    //then we will pass that token in setAuthToken method
    setAuthToken(token);
    store.dispatch(loadUser());
  }, []);

  // Socket connection management
  useEffect(() => {
    const token = localStorage.getItem('token');

    if (isAuthenticated && token) {
      // Connect socket when user is logged in
      if (!socket.connected) {
        socket.auth = { token };
        socket.connect();
        console.log('🔌 Connecting socket for authenticated user...');
      }
    } else {
      // Disconnect when logged out
      if (socket.connected) {
        socket.disconnect();
        console.log('🔌 Disconnecting socket...');
      }
    }

    // Cleanup on unmount
    return () => {
      if (socket.connected) {
        socket.disconnect();
      }
    };
  }, [isAuthenticated]);

  return (
    // <Provider store={store}>
    <Router>
      {/* Only run socket/notification logic for authenticated users */}
      <AuthenticatedEffects isAuthenticated={isAuthenticated} user={user} />
      <Switch>
        <BeforeLoginRoutes exact path='/' component={Login} />
        <PrivateRoutes exact path='/dashboard' component={Dashboard} />
        <PrivateRoutes exact path='/ads-dashboard' component={AdsDashboard} />
        <PrivateRoutes exact path='/profile' component={Profile} />

        <RoleBasedRoute
          exact
          path='/clients'
          component={AllClients}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/clients/add'
          component={AddClient}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/clients/:id/view'
          component={ViewClient}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/clients/:id/client-view'
          component={ClientView}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/clients/:id/edit'
          component={EditClient}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        {/* <RoleBasedRoute
          exact
          path='/clients/:id/dashboard'
          component={ClientDashboard}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        /> */}
        <RoleBasedRoute
          exact
          path='/clients/superadmin/dashboard'
          component={SuperAdminDashboard}
          allowedRoles={['SUPER ADMIN']}
        />

        <RoleBasedRoute
          exact
          path='/employees'
          component={AllEmployees}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/employees/add'
          component={AddEmployee}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/employees/:id/view'
          component={ViewEmployee}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'USER']}
        />
        <RoleBasedRoute
          exact
          path='/employees/:id/edit'
          component={EditEmployee}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <RoleBasedRoute
          exact
          path='/statuss'
          component={AllStatuss}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/statuss/add'
          component={AddStatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/statuss/:id/view'
          component={ViewStatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/statuss/:id/edit'
          component={EditStatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <PrivateRoutes exact path='/activitys' component={AllActivitys} />
        <PrivateRoutes
          exact
          path='/activitys/bulk-add'
          component={BulkAddActivity}
        />
        <PrivateRoutes exact path='/activitys/add' component={AddActivity} />
        <PrivateRoutes
          exact
          path='/activitys/multiple-add'
          component={AddMultipleActivity} // Assuming this is the new component
        />
        <PrivateRoutes
          exact
          path='/activitys/:id/view'
          component={ViewActivity}
        />
        <PrivateRoutes
          exact
          path='/activitys/:id/edit'
          component={EditActivity}
        />

        {/* Role-based route for Bills */}
        <RoleBasedRoute
          exact
          path='/bills'
          component={AllBills}
          allowedRoles={['SUPER ADMIN', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/bills/add'
          component={AddBill}
          allowedRoles={['SUPER ADMIN', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/bills/:id/view'
          component={ViewBill}
          allowedRoles={['SUPER ADMIN', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/bills/:id/edit'
          component={EditBill}
          allowedRoles={['SUPER ADMIN', 'ACCOUNTANT']}
        />

        <RoleBasedRoute
          exact
          path='/processs'
          component={AllProcesss}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'USER']}
        />
        <RoleBasedRoute
          exact
          path='/processs/add'
          component={AddProcess}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'USER']}
        />
        <RoleBasedRoute
          exact
          path='/processs/:id/view'
          component={ViewProcess}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'USER']}
        />
        <RoleBasedRoute
          exact
          path='/processs/:id/edit'
          component={EditProcess}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'USER']}
        />
        <RoleBasedRoute
          exact
          path='/bankaccounts'
          component={AllBankaccounts}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/bankaccounts/add'
          component={AddBankaccount}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/bankaccounts/:id/view'
          component={ViewBankaccount}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/bankaccounts/:id/edit'
          component={EditBankaccount}
          allowedRoles={['SUPER ADMIN', 'MANAGER', 'ACCOUNTANT']}
        />
        <RoleBasedRoute
          exact
          path='/activitystatuss'
          component={AllActivitystatuss}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/activitystatuss/add'
          component={AddActivitystatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/activitystatuss/:id/view'
          component={ViewActivitystatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/activitystatuss/:id/edit'
          component={EditActivitystatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <RoleBasedRoute
          exact
          path='/reviewstatuss'
          component={AllReviewstatuss}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/reviewstatuss/add'
          component={AddReviewstatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/reviewstatuss/:id/view'
          component={ViewReviewstatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/reviewstatuss/:id/edit'
          component={EditReviewstatus}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <RoleBasedRoute
          exact
          path='/leads'
          component={AllLeads}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/leads/add'
          component={AddLead}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/leads/:id/view'
          component={ViewLead}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/leads/:id/edit'
          component={EditLead}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <RoleBasedRoute
          exact
          path='/groups'
          component={AllGroups}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/groups/add'
          component={AddGroup}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/groups/:id/view'
          component={ViewGroup}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/groups/:id/edit'
          component={EditGroup}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <RoleBasedRoute
          exact
          path='/servicepackages'
          component={AllServicepackages}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/servicepackages/add'
          component={AddServicepackage}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/servicepackages/:id/view'
          component={ViewServicepackage}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/servicepackages/:id/edit'
          component={EditServicepackage}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <RoleBasedRoute
          exact
          path='/billreviews'
          component={AllBillreviews}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/billreviews/add'
          component={AddBillreview}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/billreviews/:id/view'
          component={ViewBillreview}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />
        <RoleBasedRoute
          exact
          path='/billreviews/:id/edit'
          component={EditBillreview}
          allowedRoles={['SUPER ADMIN', 'MANAGER']}
        />

        <PrivateRoutes exact path='/ads' component={AllAds} />
        <PrivateRoutes exact path='/import-csv' component={ImoortCSV} />
        <PrivateRoutes exact path='/ads/add' component={AddAd} />
        <PrivateRoutes exact path='/ads/:id/view' component={ViewAd} />
        <PrivateRoutes exact path='/ads/:id/edit' component={EditAd} />

        {/* Ads Activities Routes */}
        <PrivateRoutes
          exact
          path='/ads-activities'
          component={AdsActivitiesList}
        />
        <PrivateRoutes
          exact
          path='/ads-activities/create'
          component={AdsActivityCreate}
        />
        <PrivateRoutes
          exact
          path='/ads-activities/:id'
          component={AdsActivityDetails}
        />

        <PrivateRoutes
          exact
          path='/activity-cycles'
          component={AllActivitycycles}
        />
        <PrivateRoutes
          exact
          path='/activity-cycles/add-calendar'
          component={AddCalendar}
        />
        <PrivateRoutes
          exact
          path='/activity-cycles/add'
          component={AddActivitycycle}
        />
        <PrivateRoutes
          exact
          path='/activity-cycles/:id/view'
          component={ViewActivitycycle}
        />
        <PrivateRoutes
          exact
          path='/activity-cycles/:id/edit'
          component={EditActivitycycle}
        />
        <PrivateRoutes exact path='/adsreports' component={AllAdsreports} />
        <PrivateRoutes
          exact
          path='/adsreports/campaign-details'
          component={CampaignDetailsView}
        />
        {/* <PrivateRoutes
          exact
          path='/adsreports-facebook'
          component={AllFacebookAdsreports}
        /> */}
        <PrivateRoutes
          exact
          path='/facebook-ads-reports'
          component={AllFacebookAdsReports}
        />
        {/* <PrivateRoutes
          exact
          path='/facebook-ads-reports/upload'
          component={UploadFacebookAdsReport}
        /> */}

        {/* <PrivateRoutes
          exact
          path='/adsreports/upload-google-report'
          component={UploadGoogleReport}
        /> */}
        {/* <PrivateRoutes
          exact
          path='/adsreports/upload-facebook-report'
          component={UploadFacebookReport}
        /> */}

        <PrivateRoutes
          exact
          path='/employeereports'
          component={AllEmployeereports}
        />
        <Route exact path='/my-profile' component={MyProfile} />
        <PrivateRoutes
          exact
          path='/employeereports/add'
          component={AddEmployeereport}
        />
        <PrivateRoutes
          exact
          path='/employeereports/:id/view'
          component={ViewEmployeereport}
        />
        <PrivateRoutes
          exact
          path='/employeereports/:id/edit'
          component={EditEmployeereport}
        />
        <PrivateRoutes exact path='/events' component={Event} />
        <PrivateRoutes exact path='/clients-ads' component={ClientsAds} />
        <PrivateRoutes
          exact
          path='/clients-ads/:id'
          component={SingleClientAds}
        />
        <PrivateRoutes
          exact
          path='/client-ads-model'
          component={ClientAdsModel}
        />
        <PrivateRoutes exact path='/xchat' component={Chat} />
        <PrivateRoutes exact path='/test' component={Test} />
        <RoleBasedRoute
          path='/gallery'
          component={GalleryPage}
          allowedRoles={['SUPER ADMIN']}
        />

        <Route component={PageNotFound} />
      </Switch>
    </Router>
    // </Provider>
  );
}

export default App;

//dummy push
